export default __webpack_public_path__ + "static/media/arCube2.bd37fa1d.svg";